import { createSelector } from 'reselect';

// utils
import { getInitialFieldValues } from '../utils/fields';

import getOAuthExtraFields from './getOAuthExtraFields';

export default createSelector([getOAuthExtraFields], registrationFields => {
  const visible = registrationFields?.visible;
  const hidden = registrationFields?.hidden;

  return {
    visible: getInitialFieldValues(visible),
    hidden: getInitialFieldValues(hidden),
  };
});
